import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-borders" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Organization name")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Business id")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Vat Id")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Customer Number")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Address", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Payment terms", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Payment terms")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Contact data", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Invoice Detail", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Invoice reference")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Invoice description")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Delivery policy", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Delivery policy type")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Billing email")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_agreements_billing_info_editable_field_organization_name = _resolveComponent("agreements-billing-info-editable-field-organization-name")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_agreements_billing_info_editable_field_business_id = _resolveComponent("agreements-billing-info-editable-field-business-id")!
  const _component_agreements_billing_info_editable_field_vat_id = _resolveComponent("agreements-billing-info-editable-field-vat-id")!
  const _component_agreements_billing_info_editable_field_customer_number = _resolveComponent("agreements-billing-info-editable-field-customer-number")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_agreements_billing_info_open_dialog_field_address = _resolveComponent("agreements-billing-info-open-dialog-field-address")!
  const _component_agreements_billing_info_editable_field_payment_terms = _resolveComponent("agreements-billing-info-editable-field-payment-terms")!
  const _component_agreements_billing_info_open_dialog_fields_contact_data = _resolveComponent("agreements-billing-info-open-dialog-fields-contact-data")!
  const _component_agreements_billing_info_editable_field_invoice_reference = _resolveComponent("agreements-billing-info-editable-field-invoice-reference")!
  const _component_agreements_billing_info_editable_field_invoice_description = _resolveComponent("agreements-billing-info-editable-field-invoice-description")!
  const _component_agreements_billing_info_open_dialog_field_delivery_policy = _resolveComponent("agreements-billing-info-open-dialog-field-delivery-policy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_list, {
      class: "q-mb-lg rounded-borders",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_agreements_billing_info_editable_field_organization_name, {
                  modelValue: _ctx.billingInfoModel.organizationName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.billingInfoModel.organizationName) = $event)),
                  agreementId: _ctx.agreementId,
                  billingInfoId: _ctx.billingInfoId
                }, null, 8, ["modelValue", "agreementId", "billingInfoId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_agreements_billing_info_editable_field_business_id, {
                  modelValue: _ctx.billingInfoModel.businessId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.billingInfoModel.businessId) = $event)),
                  agreementId: _ctx.agreementId,
                  billingInfoId: _ctx.billingInfoId
                }, null, 8, ["modelValue", "agreementId", "billingInfoId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_agreements_billing_info_editable_field_vat_id, {
                  modelValue: _ctx.billingInfoModel.vatId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.billingInfoModel.vatId) = $event)),
                  agreementId: _ctx.agreementId,
                  billingInfoId: _ctx.billingInfoId
                }, null, 8, ["modelValue", "agreementId", "billingInfoId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_agreements_billing_info_editable_field_customer_number, {
                  modelValue: _ctx.billingInfoModel.customerNumber,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.billingInfoModel.customerNumber) = $event)),
                  agreementId: _ctx.agreementId,
                  billingInfoId: _ctx.billingInfoId
                }, null, 8, ["modelValue", "agreementId", "billingInfoId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_6,
    _createVNode(_component_q_list, {
      class: "q-mb-lg rounded-borders relative-position",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, { class: "full-width absolute-top" }, {
          default: _withCtx(() => [
            _createVNode(_component_agreements_billing_info_open_dialog_field_address, {
              value: _ctx.billingInfoAddressModel,
              agreementId: _ctx.agreementId,
              billingInfoId: _ctx.billingInfoId,
              updateAddressCallback: _ctx.onUpdateAddressCallback
            }, null, 8, ["value", "agreementId", "billingInfoId", "updateAddressCallback"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressData, (value, key) => {
          return (_openBlock(), _createBlock(_component_q_item, { key: key }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.addressLabels[key]), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(value), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _hoisted_7,
    _createVNode(_component_q_list, {
      class: "q-mb-lg rounded-borders",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_agreements_billing_info_editable_field_payment_terms, {
                  modelValue: _ctx.billingInfoModel.paymentTerms,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.billingInfoModel.paymentTerms) = $event)),
                  agreementId: _ctx.agreementId,
                  billingInfoId: _ctx.billingInfoId
                }, null, 8, ["modelValue", "agreementId", "billingInfoId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_9,
    _createVNode(_component_q_list, {
      class: "q-mb-lg rounded-borders relative-position",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, { class: "absolute-top full-width" }, {
          default: _withCtx(() => [
            _createVNode(_component_agreements_billing_info_open_dialog_fields_contact_data, {
              value: _ctx.billingInfoContactDataModel,
              agreementId: _ctx.agreementId,
              billingInfoId: _ctx.billingInfoId,
              updateContactDataCallback: _ctx.onUpdateContactDataCallback
            }, null, 8, ["value", "agreementId", "billingInfoId", "updateContactDataCallback"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingInfoContactDataModel, (value, key) => {
          return (_openBlock(), _createBlock(_component_q_item, { key: key }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.contactDataLabels[key]), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(value), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _hoisted_10,
    _createVNode(_component_q_list, {
      class: "q-mb-lg rounded-borders",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_agreements_billing_info_editable_field_invoice_reference, {
                  modelValue: _ctx.billingInfoModel.reference,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.billingInfoModel.reference) = $event)),
                  agreementId: _ctx.agreementId,
                  billingInfoId: _ctx.billingInfoId
                }, null, 8, ["modelValue", "agreementId", "billingInfoId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_agreements_billing_info_editable_field_invoice_description, {
                  modelValue: _ctx.billingInfoModel.invoiceDescription,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.billingInfoModel.invoiceDescription) = $event)),
                  agreementId: _ctx.agreementId,
                  billingInfoId: _ctx.billingInfoId
                }, null, 8, ["modelValue", "agreementId", "billingInfoId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_13,
    _createVNode(_component_q_list, {
      class: "q-mb-lg rounded-borders relative-position",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, { class: "absolute-top" }, {
          default: _withCtx(() => [
            _createVNode(_component_agreements_billing_info_open_dialog_field_delivery_policy, {
              value: _ctx.deliveryPolicyDataModel,
              agreementId: _ctx.agreementId,
              billingInfoId: _ctx.billingInfoId,
              updateDeliveryPolicyCallback: _ctx.onUpdateDeliveryPolicyCallback
            }, null, 8, ["value", "agreementId", "billingInfoId", "updateDeliveryPolicyCallback"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedDeliveryPolicyType.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.isElectronic)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.electronicData, (value, key) => {
              return (_openBlock(), _createBlock(_component_q_item, { key: key }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.electronicLabels[key]), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(value), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.isEmail)
          ? (_openBlock(), _createBlock(_component_q_item, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.deliveryPolicyDataModel.email), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}